(function () {
   'use strict';

   const MOBILE_QUERY = '(max-width: 767.98px)';
   const STICKY_TOP = 56; // altura do header fixo no mobile
   const TOP_GAP = 16; // respiro entre o header e o primeiro card fixado

   const viewport = document.getElementById('homeQuemViewport');
   const strip = document.getElementById('homeQuemStrip');
   const prev = document.getElementById('homeQuemPrev');
   const next = document.getElementById('homeQuemNext');
   const section = document.querySelector('.home-quem-somos');
   const carousel = document.querySelector('.home-quem-somos__carousel');

   if (!viewport || !strip) return;

   const getCards = () => Array.from(strip.querySelectorAll('.home-quem-card'));
   const isMobile = () => window.matchMedia(MOBILE_QUERY).matches;

   // ---------------------------------------------------------------------------
   // Mobile — cards empilhados com `position: sticky` (stacking cards).
   // Cada card gruda logo abaixo do header, com offset acumulado pela altura dos
   // títulos dos cards anteriores. Ao rolar, o próximo card sobe e cobre o
   // anterior (sobrando só o título); o último permanece totalmente aberto.
   // Efeito 100% nativo do scroll → sem buraco, sem espaço reservado e sem
   // brigar com a rolagem da página.
   // ---------------------------------------------------------------------------
   let scrollMode = null;
   let onResize = null;
   let resizeRaf = null;

   // Define o `top` sticky de cada card como a soma das alturas dos títulos dos
   // cards acima dele (assim cada título "fica de fora" quando coberto).
   function setStickyTops() {
      const cards = getCards();
      let top = STICKY_TOP + TOP_GAP;

      cards.forEach((card, index) => {
         card.style.top = `${top}px`;
         card.style.zIndex = String(index + 1);
         card.setAttribute('aria-expanded', 'true');

         const title = card.querySelector('.home-quem-card__title');
         // offsetHeight é mais confiável que getBoundingClientRect aqui.
         const titleH = title ? title.offsetHeight : 56;
         top += titleH;
      });
   }

   function destroyScrollAccordion() {
      if (onResize) {
         window.removeEventListener('resize', onResize);
         onResize = null;
      }

      if (resizeRaf) {
         cancelAnimationFrame(resizeRaf);
         resizeRaf = null;
      }

      scrollMode = null;

      getCards().forEach((card) => {
         card.style.top = '';
         card.style.zIndex = '';
         card.removeAttribute('aria-expanded');
      });
   }

   function initScrollAccordion() {
      if (scrollMode) return;

      destroyCarouselListeners();
      scrollMode = true;

      if (section) {
         section.classList.add('home-quem-somos--scroll-accordion');
      }

      if (carousel) {
         carousel.setAttribute('aria-roledescription', 'accordion');
      }

      viewport.setAttribute('aria-roledescription', 'accordion');

      setStickyTops();
      // Recalcula após o layout assentar e as fontes carregarem (a altura dos
      // títulos define o offset de cada card empilhado).
      requestAnimationFrame(() => requestAnimationFrame(setStickyTops));
      if (document.fonts && document.fonts.ready) {
         document.fonts.ready.then(() => {
            if (scrollMode) setStickyTops();
         });
      }

      onResize = () => {
         if (resizeRaf) cancelAnimationFrame(resizeRaf);
         resizeRaf = requestAnimationFrame(setStickyTops);
      };

      window.addEventListener('resize', onResize);
   }

   // ---------------------------------------------------------------------------
   // Desktop — carrossel horizontal com setas
   // ---------------------------------------------------------------------------
   let carouselMode = null;
   let activeIndex = 1;
   let resizeTimer = null;

   const AUTOPLAY_DELAY = 6000; // 6s — avança sozinho no desktop
   const QUEM_CARD_DUR_MS = 600;
   let autoplayTimer = null;
   let wrapUnderTimer = null;

   function ordersForActiveIndex(index, total) {
      if (total !== 3) return null;
      if (index === 0) return [2, 3, 1];
      if (index === 1) return [1, 2, 3];
      return [3, 1, 2];
   }

   /** Índices dos cards que saem da esquerda (order 1) para a direita (order 3). */
   function getWrapUnderIndices(fromIndex, toIndex, total) {
      const oldOrders = ordersForActiveIndex(fromIndex, total);
      const newOrders = ordersForActiveIndex(toIndex, total);
      if (!oldOrders || !newOrders) return [];

      const indices = [];
      for (let i = 0; i < total; i++) {
         if (oldOrders[i] === 1 && newOrders[i] === 3) indices.push(i);
      }
      return indices;
   }

   function clearWrapUnder(cards) {
      cards.forEach((card) => card.classList.remove('is-wrap-under'));
   }

   function scheduleClearWrapUnder(cards) {
      if (wrapUnderTimer) window.clearTimeout(wrapUnderTimer);
      wrapUnderTimer = window.setTimeout(function () {
         wrapUnderTimer = null;
         clearWrapUnder(cards);
      }, QUEM_CARD_DUR_MS);
   }

   function clearCardMotionStyles(cards) {
      cards.forEach((card) => {
         card.style.transitionProperty = '';
         card.style.transform = '';
      });
      clearWrapUnder(cards);
      if (wrapUnderTimer) {
         window.clearTimeout(wrapUnderTimer);
         wrapUnderTimer = null;
      }
   }

   /** FLIP: desloca cada card do layout antigo ao novo para a troca ser perceptível nos 3. */
   function flipStrip(cards, applyChange, done) {
      const firstRects = cards.map((card) => card.getBoundingClientRect());

      applyChange();

      window.requestAnimationFrame(() => {
         let moved = false;

         cards.forEach((card, index) => {
            const first = firstRects[index];
            const last = card.getBoundingClientRect();
            const dx = first.left - last.left;
            const dy = first.top - last.top;

            if (Math.abs(dx) < 0.5 && Math.abs(dy) < 0.5) return;

            moved = true;
            card.style.transform = 'translate(' + dx + 'px, ' + dy + 'px)';
            // Mantém width/height animando; só congela transform neste frame.
            card.style.transitionProperty = 'width, height, box-shadow';
         });

         if (!moved) {
            if (done) done();
            return;
         }

         window.requestAnimationFrame(() => {
            cards.forEach((card) => {
               if (!card.style.transform) return;
               card.style.transitionProperty = '';
               card.style.transform = '';
            });

            if (done) done();
         });
      });
   }

   function autoplayStep() {
      const last = getCards().length - 1;
      // Ao chegar no fim, volta ao início e recomeça.
      scrollToIndex(activeIndex >= last ? 0 : activeIndex + 1, false);
   }

   function startAutoplay() {
      stopAutoplay();
      if (getCards().length <= 1) return;
      autoplayTimer = window.setInterval(autoplayStep, AUTOPLAY_DELAY);
   }

   function stopAutoplay() {
      if (autoplayTimer) {
         window.clearInterval(autoplayTimer);
         autoplayTimer = null;
      }
   }

   function restartAutoplay() {
      if (carouselMode) startAutoplay();
   }

   function onCarouselEnter() { stopAutoplay(); }
   function onCarouselLeave() { restartAutoplay(); }

   function setFlexOrder() {
      const cards = getCards();
      if (cards.length !== 3) return;

      const orders = activeIndex === 0 ? [2, 3, 1] : activeIndex === 1 ? [1, 2, 3] : [3, 1, 2];
      cards.forEach((card, index) => {
         card.style.order = String(orders[index]);
      });
   }

   function alignStrip(instant) {
      const maxScroll = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
      const target = maxScroll < 1 ? 0 : maxScroll / 2;

      if (instant) {
         viewport.scrollLeft = target;
         return;
      }

      viewport.scrollTo({ left: target, behavior: 'smooth' });
   }

   function syncCarouselVisual() {
      const cards = getCards();
      const lastIndex = cards.length - 1;

      activeIndex = Math.max(0, Math.min(activeIndex, lastIndex));
      setFlexOrder();

      cards.forEach((card, index) => {
         const isActive = index === activeIndex;
         card.classList.toggle('is-active', isActive);

         if (isActive) {
            card.setAttribute('aria-current', 'true');
            const img = card.querySelector('img');
            const title = card.querySelector('.home-quem-card__title');
            if (img && title) img.setAttribute('alt', title.textContent.trim());
         } else {
            card.removeAttribute('aria-current');
            const img = card.querySelector('img');
            if (img) img.setAttribute('alt', '');
         }
      });

      // Carrossel cíclico (loop infinito): as setas nunca bloqueiam.
      if (prev) prev.disabled = false;
      if (next) next.disabled = false;
   }

   function scrollToIndex(index, instant) {
      const cards = getCards();
      const wrapUnderIndices = getWrapUnderIndices(activeIndex, index, cards.length);

      function afterVisual() {
         window.requestAnimationFrame(() => {
            alignStrip(instant);
         });
      }

      if (instant || !carouselMode) {
         activeIndex = index;
         syncCarouselVisual();
         clearCardMotionStyles(cards);
         afterVisual();
         return;
      }

      flipStrip(
         cards,
         function () {
            clearWrapUnder(cards);
            wrapUnderIndices.forEach(function (i) {
               cards[i].classList.add('is-wrap-under');
            });
            activeIndex = index;
            syncCarouselVisual();
            scheduleClearWrapUnder(cards);
         },
         afterVisual
      );
   }

   function goPrev() {
      const total = getCards().length;
      if (total <= 1) return;
      // Cíclico: do primeiro volta para o último.
      scrollToIndex((activeIndex - 1 + total) % total, false);
   }

   function goNext() {
      const total = getCards().length;
      if (total <= 1) return;
      // Cíclico: do último volta para o primeiro.
      scrollToIndex((activeIndex + 1) % total, false);
   }

   function onPrevClick() { goPrev(); restartAutoplay(); }
   function onNextClick() { goNext(); restartAutoplay(); }

   function onKeydown(event) {
      if (event.key === 'ArrowLeft') {
         event.preventDefault();
         goPrev();
         restartAutoplay();
      }

      if (event.key === 'ArrowRight') {
         event.preventDefault();
         goNext();
         restartAutoplay();
      }
   }

   function onCarouselResize() {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(() => scrollToIndex(activeIndex, true), 120);
   }

   function destroyCarouselListeners() {
      stopAutoplay();
      if (prev) prev.removeEventListener('click', onPrevClick);
      if (next) next.removeEventListener('click', onNextClick);
      viewport.removeEventListener('keydown', onKeydown);
      window.removeEventListener('resize', onCarouselResize);
      if (carousel) {
         carousel.removeEventListener('mouseenter', onCarouselEnter);
         carousel.removeEventListener('mouseleave', onCarouselLeave);
         carousel.removeEventListener('focusin', onCarouselEnter);
         carousel.removeEventListener('focusout', onCarouselLeave);
      }
   }

   function initCarousel() {
      if (carouselMode) return;

      destroyScrollAccordion();
      carouselMode = true;

      if (section) {
         section.classList.remove('home-quem-somos--scroll-accordion');
      }

      if (carousel) {
         carousel.setAttribute('aria-roledescription', 'carrossel');
      }

      viewport.setAttribute('aria-roledescription', 'carrossel');

      getCards().forEach((card) => {
         card.style.order = '';
         card.style.transitionProperty = '';
         card.style.transform = '';
         card.removeAttribute('aria-expanded');
         const panel = card.querySelector('.home-quem-card__panel');
         if (panel) panel.style.maxHeight = '';
      });

      if (prev) prev.addEventListener('click', onPrevClick);
      if (next) next.addEventListener('click', onNextClick);
      viewport.addEventListener('keydown', onKeydown);
      window.addEventListener('resize', onCarouselResize);

      // Pausa o autoplay ao interagir (hover/foco) e retoma ao sair.
      if (carousel) {
         carousel.addEventListener('mouseenter', onCarouselEnter);
         carousel.addEventListener('mouseleave', onCarouselLeave);
         carousel.addEventListener('focusin', onCarouselEnter);
         carousel.addEventListener('focusout', onCarouselLeave);
      }

      scrollToIndex(activeIndex, true);
      startAutoplay();
   }

   function pickMode() {
      carouselMode = null;
      scrollMode = null;

      if (isMobile()) {
         initScrollAccordion();
      } else {
         initCarousel();
      }
   }

   if (document.readyState === 'complete') {
      pickMode();
   } else {
      window.addEventListener('load', pickMode);
   }

   window.matchMedia(MOBILE_QUERY).addEventListener('change', () => {
      destroyScrollAccordion();
      destroyCarouselListeners();
      carouselMode = null;
      scrollMode = null;
      pickMode();
   });
})();
